.footerContainer {
  gap: 40px;
  width: 90%;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 120px;
}

.returnsLogo {
  width: 100%;
}

.returnsLogo img {
  width: 100%;
}

.contactCTA {
  color: var(--text-color-5);
  width: 100%;
  gap: 70px;
  display: flex;
  justify-content: space-between;
}

.contactParent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  max-width: 580px;
}

.returnsDetailsFooter {
  text-align: left;
  line-height: 24px;
  margin: 0;
}

.importantLinksCopyright {
  display: flex;
  gap: 70px;
}

.importantLinks {
  width: 781;
  gap: 52px;
  display: flex;
}

.importantLinks div {
  align-items: start;
  gap: 20px;
  display: flex
;
}

.importantLinks span {
  font-weight: 400;
  font-size: 16px;
  color: var(--text-color-1);
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-align: start;
}

.CTA {
  display: flex;
  flex-direction: column;
}

.CTADesc {
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  margin-bottom: 22px;
  text-align: start;
  color: var(--text-color-1);
}

.legalitiesParent {
  gap: 5px;
  display: flex;
  justify-content: space-between;
}

.copyrightLicence {
  gap: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 24px;
  text-align: left;
}

.footerContact svg {
  height: 16px;
}

.footerLine {
  width: 100%;
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  margin-bottom: 0px;
  margin-top: 0;
}

.hr1 {
  display: none;
}

.hr3 {
  display: none;
}

.footerContact {
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: end;
}

.footerContact span {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
}

.extraDetails p {
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-align: start;
  margin: 0 0 20px;
}

@media (max-width: 990px) {
  .footerContainer {
    margin-bottom: 80px;
  }
  .CTADesc {
    font-size: 24px;
    font-weight: 500;
  }
  .contactCTA, .importantLinksCopyright {
    gap: 40px;
    flex-direction: column;
  }
  .importantLinks {
    gap: 40px;
    width: unset;
  }
  .footerContact {
    gap: 8px;
  }
}

@media (max-width: 720px) {
  .footerContainer {
    gap: 20px;
    margin-bottom: 42px;
  }
  .importantLinks div {
    gap: 24px;
  }
  .importantLinks div span {
    font-size: 14px;
  }
  .contactCTA, .importantLinksCopyright {
    flex-direction: column;
    height: unset;
    gap: 20px;
  }
  .hr1 {
    display: unset;
    margin-bottom: 24px;
  }
  .hr2 {
    display: none;
  }
  .hr3 {
    display: unset;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .CTADesc {
    margin-bottom: unset;
  }
  .legalitiesParent {
    flex-direction: column-reverse;
    font-size: 14px;
  }
  .footerContact {
    flex-direction: row;
  }
  .extraDetails p {
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0 0 16px;
  }
}

@media (max-width: 480px) {
  .footerContact {
    flex-direction: row;
    flex-direction: column;
  }
  .copyrightLicence div {
    text-align: left;
  }
  .importantLinks {
    gap: 12px;
    flex-direction: column;
  }
}